import { ReactElement } from 'react';
import { CreditsTable } from './CreditsTable';
import { Stack, Typography } from '@mui/material';
import { SearchStringFilter } from './SearchStringFilter';
import { FilterOptions } from './FilterOptions';

export const Table = (): ReactElement => {
  return (
    <Stack>
      <Stack direction="row" gap={1} alignItems="center" pb={1}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.09 10.37C19.0353 10.7224 19.8765 11.3075 20.5358 12.0712C21.195 12.8349 21.6511 13.7524 21.8617 14.7391C22.0724 15.7257 22.0309 16.7495 21.741 17.7158C21.4512 18.6822 20.9223 19.5598 20.2034 20.2676C19.4845 20.9754 18.5987 21.4905 17.628 21.7652C16.6572 22.04 15.6329 22.0655 14.6497 21.8395C13.6665 21.6134 12.7561 21.1431 12.0028 20.472C11.2495 19.8009 10.6776 18.9507 10.34 18M7 6H8V10M16.71 13.88L17.41 14.59L14.59 17.41M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
            stroke="#1D2146"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <Typography fontSize={24}>Credits</Typography>
      </Stack>
      <Stack
        direction="row"
        gap={4}
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Stack width={'50%'}>
          <SearchStringFilter />
        </Stack>
        <FilterOptions />
      </Stack>
      <CreditsTable />
    </Stack>
  );
};
